function isIsolatedMode() {
  return process.env.REACT_APP_MODE === 'isolated';
}

export default isIsolatedMode;
